<script>
import axios from 'axios';
export default {
    props: {
        categorias: {
            type: Array,
            required: true,
        },
        seriesData: {
            type: Array,
            required: true,
        },
        colores: {
            type: Array,
            required: true,
        },
        title:""
    },
    data() {
        return {
            isActive: "day",
            chartOptions: {
                chart: {
                    stacked: true,
                    toolbar: { show: false },
                    zoom: { enabled: true },
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: "75%",
                        endingShape: "rounded",
                    },
                },
                dataLabels: { enabled: false },
                tooltip: {
                    shared: true,
                    intersect: false, 
                    custom: function({ series, seriesIndex, dataPointIndex, w }) {
                        const formatNumber = (number) => {
                            return new Intl.NumberFormat("es-CL", {
                                style: "decimal",
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 2
                            }).format(number);
                        };
                        // Calcular el total del día actual
                        const total = w.globals.series
                            .map(series => series[dataPointIndex])
                            .reduce((a, b) => a + b, 0);

                        // Crear el HTML del tooltip
                        let tooltipHtml = `<div class="custom-tooltip">`;
                        tooltipHtml += `<div class="tooltip-date" style="text-align: center;margin-top: 5px;">${w.globals.labels[dataPointIndex]}</div><hr>`;

                        // Recorrer cada serie y mostrar su valor con el color correspondiente
                        w.globals.seriesNames.forEach((name, i) => {
                            const value = w.globals.series[i][dataPointIndex];
                            const color = w.globals.colors[i];
                            tooltipHtml += `
                                <div class="tooltip-series" style="border-left: 4px solid ${color}; padding-left: 8px;">
                                    <strong>${name}:</strong> ${formatNumber(value)}
                                </div>`;
                        });

                        // Agregar el total al final
                        tooltipHtml += `<hr><div class="tooltip-total"><strong>Total: ${formatNumber(total)}</strong></div>`;
                        tooltipHtml += `</div>`;

                        return tooltipHtml;
                    }
                }
                ,
                xaxis: {
                    categories: [...this.categorias], // Inicialmente vacío
                },
                colors: [],
                legend: { position: "bottom" },
                fill: { opacity: 1 },
            },
        };
    },
    computed: {
        seriesLocal() {
            return Array.isArray(this.seriesData) ? this.seriesData : [];
        },
        coloresParaGrafico() {
            const titulo = String(this.title || '').toLowerCase();
            if (titulo.includes('ventas diarias por canal')) {
                return ['#6f42c1'];
            }
            return Array.isArray(this.colores) ? this.colores : [];
        },
        chartOptionsConColor() {
            return {
                ...this.chartOptions,
                colors: [...this.coloresParaGrafico],
                xaxis: {
                    ...this.chartOptions.xaxis,
                    categories: [...this.categorias],
                },
            };
        },
    },
    methods: {
        formatNumber(num) {
            num = parseInt(num, 10);

            // Verificar si la conversión fue exitosa (parseInt puede devolver NaN en ciertos casos)
            if (isNaN(num)) {
                return 0;  // Retornar 0 si la conversión falla
            }
            if (num==0) {
                return '$0';  // Retornar 0 si la conversión falla
            }
            if(true){
                return num ? num.toLocaleString("es-CL", {style: "currency", currency: "CLP"}) : null;
            }else{
                return Math.round(num)
            }
        },
    },
    mounted() {
        
    },
    created() {
    },
};
</script>

<style scoped>
.custom-tooltip {
    background: #ffffff;
    color: #333;
    padding: 15px;
    border-radius: 10px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
    font-size: 10px;
    min-width: 150px;
    text-align: left;
    font-family: 'Poppins', sans-serif;
}

.tooltip-date {
    font-size: 11px;
    font-weight: bold;
    color: #666;
    margin-bottom: 8px;
}

.tooltip-series {
    display: flex;
    align-items: center;
    margin: 6px 0;
    color: #444;
}

.tooltip-total {
    font-weight: bold;
    font-size: 10px;
    color: #222;
    text-align: right;
    margin-top: 10px;
}

</style>

<template>
    <div class="card">
        <div class="card-body">
            <div class="d-sm-flex flex-wrap">
                <h4 class="card-title mb-4">{{ title }}</h4>
                <div class="ms-auto">
                    <ul class="nav nav-pills">
                        <!-- <li class="nav-item">
                            <a class="nav-link" href="javascript: void(0);" @click="changeVal('day')"
                                :class="{ 'active': isActive === 'day' }">Day</a>
                        </li> -->
                        <!-- <li class="nav-item">
                            <a class="nav-link" href="javascript: void(0);" @click="changeVal('week')"
                                :class="{ 'active': isActive === 'week' }">Week</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="javascript: void(0);" @click="changeVal('month')"
                                :class="{ 'active': isActive === 'month' }">Month</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="javascript: void(0);" @click="changeVal('year')"
                                :class="{ 'active': isActive === 'year' }">Year</a>
                        </li> -->
                    </ul>
                </div>
            </div>

            <apexchart class="apex-charts" type="bar" dir="ltr" height="360" :series="seriesLocal"
                :options="chartOptionsConColor" />
        </div>
    </div>
</template>